import './StoresByCategoryPage.less';

export const prefix = 'bm-p-stores-by-category';

export { default } from './StoresByCategoryPage';
